module.exports = __webpack_public_path__ + "img/404-no-data-found.44114434.jpg";